export default __webpack_public_path__ + "static/media/zuLogo.7a3331ab.svg";